var render, staticRenderFns
import script from "./inquery-result.vue?vue&type=script&lang=js&"
export * from "./inquery-result.vue?vue&type=script&lang=js&"
import style0 from "./inquery-result.vue?vue&type=style&index=0&id=4ab24073&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab24073",
  null
  
)

export default component.exports